import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(id, startDate, startTime, days, endTime, priority) {
  return yield oncallFetch("/api/oncall/partners/shifts-definitions/update", {
    id,
    startDate,
    startTime,
    days,
    endTime,
    priority,
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/partners/shifts-definitions/update.js